import React, { useRef } from 'react';
import { Select } from 'antd';
import useRequestStreets from '../../../../../../../queries/useRequestStreets';
import { useStreetState, useAddressDispatch } from '../../lib';
import { changeStreet } from '../../model/actionTypes';
import { useSearchParams } from '../../../../../shared/lib/searchParams';
import { shutdownFiltersData } from '../../../../../shared/constants';
import { debounce } from '../../../../../../../helpers/debounce';
import { useMeasure } from '../../../../../../../hooks/useMeasure';
import TextWithTooltip from '../../../../../../../components/TextWithTooltip/TextWithTooltip';
import BlockWithExtraContent from '../../../../../../../components/BlockWithExtraContent/BlockWithExtraContent';

const {
  filters: { street: streetFilter, house, search },
  changeFilterDelay: delay,
} = shutdownFiltersData;

const OptionContent = ({ street }) => {
  const [ref, { width }] = useMeasure();

  return (
    <div ref={ref}>
      <TextWithTooltip
        parentWidth={width}
        mainTitle={[street.name, Boolean(street.city) && `(${street.city})`]
          .filter(Boolean)
          .join(' ')}
        render={({ textRef, ...props }) => (
          <BlockWithExtraContent
            {...props}
            ref={textRef}
            main={street.name}
            extra={street.city}
          />
        )}
      />
    </div>
  );
};

const SelectStreet = ({ className }) => {
  const street = useStreetState();
  const dispatch = useAddressDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: streets, isFetching } = useRequestStreets({
    staleTime: Infinity,
  });

  const handleChange = (value) => {
    dispatch({ type: changeStreet, payload: value });

    debounce(() => {
      const newParams = new URLSearchParams(searchParams);

      Boolean(value?.trim())
        ? newParams.set(streetFilter.name, value.trim())
        : newParams.delete(streetFilter.name);

      newParams.delete(house.name);
      setSearchParams(newParams);
    }, delay)();
  };

  const ref = useRef();

  return (
    <Select
      className={className}
      loading={isFetching}
      allowClear={true}
      placeholder="Выберите улицу"
      value={isFetching ? undefined : street}
      optionFilterProp="searchtext"
      showSearch
      optionLabelProp="label"
      onChange={handleChange}
    >
      {streets?.map((street) => (
        <Select.Option
          ref={ref}
          key={street.id}
          searchtext={`${street.city || ''}${street.name}`}
          label={street.name}
        >
          <OptionContent street={street} />
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectStreet;
